// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xecpjoetpimjupcoetmp.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlY3Bqb2V0cGltanVwY29ldG1wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MDg4MDIsImV4cCI6MjA2NjA4NDgwMn0.l3mHF5-IsZlYB4LawylJXw3JSgWp2rzIw5GkTlxRRoU'; 

export const supabase = createClient(supabaseUrl, supabaseKey);
